import React from 'react'
import './scss/prodTile.scss'

export default class ProductTile extends React.Component {
  render () {
    const { product } = this.props
    let title
    let attr = {}
    let desc

    if (!Object.entries)
      {Object.entries = function (obj) {
				var ownProps = Object.keys(obj),
					i = ownProps.length,
					resArray = new Array(i); // preallocate the Array
				while (i--)
					resArray[i] = [ownProps[i], obj[ownProps[i]]];

				return resArray;
			};}

    for (let [k, v] of Object.entries(product)) {
      if (k === 'Header') {
        for (let [k1, v1] of Object.entries(v[0])) {
          if (k1 === 'HEADER COPY') {
            title = v1.value
          }
        }
      } else if (k === 'Characteristics') {
        for (let char of v) {
          if (char['HEADER COPY'].value === 'Style') {
            attr.style = char['BODY COPY'].value
          } else if (char['HEADER COPY'].value === 'Key flavour') {
            attr.flavor = char['BODY COPY'].value
          } else if (char['HEADER COPY'].value === 'Abv') {
            attr.abv = char['BODY COPY'].value
          } else if (char['HEADER COPY'].value === 'Bitterness') {
            attr.bitterness = char['BODY COPY'].value
          }
        }
      } else if (k === 'MaltsHops') {
        for (let char of v) {
          if (char['HEADER COPY'].value === 'Malt') {
            attr.malt = char['BODY COPY'].value
          } else if (char['HEADER COPY'].value === 'Hops') {
            attr.hops = char['BODY COPY'].value
          }
        }
      } else if (k === 'Description') {
        for (let [k2, v2] of Object.entries(v[0])) {
          if (k2 === 'HEADER COPY' && v2.value === 'MORE DETAILS') {
            desc = v[0]['BODY COPY'].value
          }
        }
      }
    }

    return (
      <div className={'product'}>
        <div className='product__title-wrap'>
          <h3 className={'product__title'}>{title}</h3>
          {attr.abv && <span className={'product__abv'}>{attr.abv} ABV</span>}
        </div>
        {attr.style && <div className={'product__style'}>{attr.style}</div>}
        <div className={'product__separator'} />
        <div className='product__attr-wrap'>
          {attr.flavor && <div className={'product__attr product__flavor'}><span className='product__attr-key'>Key flavours: </span><span className='product__attr-val'>{attr.flavor}</span></div>}
          {attr.malt && <div className={'product__attr product__malt'}><span className='product__attr-key'>Malt: </span><span className='product__attr-val'>{attr.malt}</span></div>}
          {attr.bitterness && <div className={'product__attr product__bitterness'}><span className='product__attr-key'>Bitterness: </span><span className='product__attr-val'>{attr.bitterness}</span></div>}
          {attr.hops && <div className={'product__attr product__hops'}><span className='product__attr-key'>Hops: </span><span className='product__attr-val'>{attr.hops}</span></div>}
        </div>
        <div className={'product__separator'} />
        {desc && <div className={'product__desc'}>{desc}</div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/beers/product-tile.js